import type { NodeDefinition } from '../../types';
import { t, r } from '../../rubyParts';
import { InputNodeView } from '../views/InputNode';

export const inputDefinition: NodeDefinition<'input'> = {
  label: 'Input',
  showInPalette: false,
  paletteColor: 'bg-teal-100 border-teal-500 text-teal-700',
  miniMapColor: '#14b8a6',
  defaultData: { label: 'Input' },
  view: InputNodeView,
  run: () => undefined,
  help: {
    title: [t('Input')],
    description: [
      r('関数', 'かんすう'),
      t('の'),
      r('処理', 'しょり'),
      t('を'),
      r('始', 'はじ'),
      t('める'),
      r('入口', 'いりぐち'),
      t('です。'),
    ],
  },
};